var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart1"},[_c('Doughnut',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.computedData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }